import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './ContactPage.css';

const ContactPage = () => {
  const [contactInfo, setContactInfo] = useState({
    phone: '0538 412 51 26',
    email: '',
    address: 'İKİTELLİ OSB MAH. AYKOSAN 4 LÜ D BLOK SK. AYKOSAN 4\'LÜ D BLOK NO: 4 D İÇ KAPI NO: 194 BAŞAKŞEHİR/ İSTANBUL',
    workingHours: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi: 09:00 - 14:00'
  });

  useEffect(() => {
    const contactRef = ref(database, 'contactInfo');
    const unsubscribe = onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setContactInfo(data);
      }
    });

    return () => unsubscribe();
  }, []);

  // Google Maps için adres URL'i
  const mapsAddress = contactInfo.address || 'İKİTELLİ OSB MAH. AYKOSAN 4 LÜ D BLOK SK. AYKOSAN 4\'LÜ D BLOK NO: 4 D İÇ KAPI NO: 194 BAŞAKŞEHİR/ İSTANBUL';

  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">İletişim</h1>
          <p className="page-hero-subtitle">
            Bize ulaşmak için aşağıdaki iletişim bilgilerini kullanabilirsiniz.
          </p>
        </div>
      </div>

      <div className="contact-page-content">
        <div className="container">
          <div className="contact-info">
            <div className="info-item">
              <h3>Müşteri Hizmetleri</h3>
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="contact-phone">
                {contactInfo.phone}
              </a>
              {contactInfo.email && (
                <a href={`mailto:${contactInfo.email}`} className="contact-email">
                  {contactInfo.email}
                </a>
              )}
            </div>
            <div className="info-item">
              <h3>Çalışma Saatleri</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{contactInfo.workingHours}</p>
            </div>
            <div className="info-item">
              <h3>Adres</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{contactInfo.address || mapsAddress}</p>
            </div>
          </div>
          <div className="maps-container">
            <div className="maps-wrapper">
              <iframe
                src={`https://www.google.com/maps?q=${encodeURIComponent(mapsAddress)}&output=embed`}
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Bulut Ambalaj Konumu"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
